/**
 * Minimal data display overrides for default MUI look.
 */
export const dataDisplayCustomizations = {};
